import React, { Component } from 'react';
import { render } from 'react-dom';

import { Provider } from 'react-redux';

import store from './store';

import Root from './containers/Root';
import 'babel-polyfill';

// 汉化
import { LocaleProvider  } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN'
// 由于 antd 对于日期组件的汉化不够彻底（项目使用的当前版本），所以使用了 moent 的日期汉化来支持日期组件的汉化
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn');

render (
    <Provider store={ store }>
        <LocaleProvider locale={zhCN}>
            <Root />
        </LocaleProvider>
    </Provider>,
    document.getElementById('root')
);